import { render, staticRenderFns } from "./RemoveBranchAction.vue?vue&type=template&id=34af7228&scoped=true&"
import script from "./RemoveBranchAction.vue?vue&type=script&lang=ts&"
export * from "./RemoveBranchAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af7228",
  null
  
)

export default component.exports